import { BrowserModule } from '@angular/platform-browser';
import { /*APP_INITIALIZER,*/ NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MarkdownModule, MarkedOptions, MarkdownService } from 'ngx-markdown';
// services
import { ApiService } from './services/api.service';
// routes
import { myRoutes } from './app.routes';
// ui components
import { AppComponent } from './app.component';

// icons
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFilePdf,
  faCheck,
  faTimes,
  faPrint,
  faWarning,faArrowLeft,faShare,faClipboard

} from '@fortawesome/free-solid-svg-icons';
//Pages
import { SearchComponent } from './pages/searches/search.component';
import { ContactComponent } from './footer/contact.component';
import { TermsComponent } from './footer/terms.component';
import { RequestComponent } from './pages/requests/request.component';
import { TankmixDetailComponent } from './pages/searches/tankmix-detail.component';
import { TankmixResultTransformPipe } from './pipes/tankmix-result-transform.pipe';
import { SearchSeedTreatmentComponent } from './pages/searches/search-seed-treatment.component';
import { RequestSeedTreatmentComponent } from './pages/requests/request-seed-treatment.component';
import { NavigationComponent } from './navigation/navigation.component';
import { PrivacyComponent } from './components/privacy.component';
import { HeaderComponent } from './components/header.component';
import { WarningEmptyIngredientComponent } from './components/warning-empty-ingredient.component';
import { FooterComponent } from './footer/footer.component';
import { RequestSubmittedComponent } from './pages/requests/request-submitted.component';
import { ArticleComponent } from './pages/article.component';
import { SearchHistoryComponent } from './pages/searches/search-history.component';
import { TermsAcceptorComponent } from './components/terms-acceptor.component';

//
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

// helena
import { HelenaSearchComponent } from './helena/pages/searches/helena-search.component';
import { HelenaTankmixDetailComponent } from './helena/pages/searches/helena-tankmix-detail.component';
import { HelenaRequestComponent } from './helena/pages/requests/helena-request.component';
import { HelenaPrivacyComponent } from './helena/helena-privacy.component';
import { HeaderHelenaComponent } from './helena/components/header-helena.component';
import { HelenaSearchSeedTreatmentComponent } from './helena/pages/searches/helena-search-seed-treatment.component';
import { HelenaRequestSeedTreatmentComponent } from './helena/pages/requests/helena-request-seed-treatment.component';
import { NavigationHelenaComponent } from './helena/navigation/navigation-helena.component';


// Locales
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

// Reuseable
import { AutoLoginComponent } from './components/auto-login.component';
import { ForbiddenComponent } from './components/forbidden.component';
import { UnauthorizedComponent } from './components/unauthorized.component';
import { CallbackComponent } from './components/callback.component';
import { PageNotFoundComponent } from './components/page-not-found.component';
import { YaraLogoComponent } from './components/yara-logo.component';
import { NameIdTypeaheadComponent } from './components/nameid-typeahead.component';
import { LanguageChooserComponent } from './components/language-chooser.component';
import { ToastsComponent } from './components/toasts.component';
//Interceptors
import { LoggingInterceptor } from './interceptors/logging-interceptor';

// Unclass
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MobileNavigationComponent } from './navigation/mobile-navigation.component';
import { HelenaArticleComponent } from './helena/pages/helena-article.component';
import { VersionUpdatesService } from "./services/version-updates-service";
import { PdfIconComponent } from './components/pdf-icon.component';
import { ResultIconComponent } from './components/result-icon.component';
import { SimpleObserverDirective } from './directives/simpleObserver';
import { YaraLogoKnowledgeGrowsComponent } from './components/yara-logo-kg.component';
import { UnitsChooserComponent } from './components/units-chooser.component';
import { HelenaLogoComponent } from './helena/components/HelenaLogoComponent';
import { SeedUnitsChooserComponent } from './components/seed-units-chooser.component';
registerLocaleData(localeFr, 'fr-FR');

library.add(faFilePdf, faCheck, faTimes, faPrint, faWarning,faArrowLeft,faShare,faClipboard /* faTrashAlt, faEdit, faCoffee, faPlus, faSearch, faCalendarAlt*/);

@NgModule({
  declarations: [
    //directives
    SimpleObserverDirective,
    
    //pipes
    TankmixResultTransformPipe,
    // top
    AppComponent,
    //Reuseable
    ToastsComponent,
    AutoLoginComponent,
    ForbiddenComponent,
    UnauthorizedComponent,
    CallbackComponent,
    PageNotFoundComponent,
    YaraLogoComponent,
    YaraLogoKnowledgeGrowsComponent,
    HelenaLogoComponent,
    NameIdTypeaheadComponent,
    LanguageChooserComponent,
    PrivacyComponent,
    HeaderComponent,
    FooterComponent,
    UnitsChooserComponent,
    SeedUnitsChooserComponent,
    //Pages
    SearchComponent,
    ContactComponent,
    TermsComponent,
    RequestComponent,
    TankmixDetailComponent,
  
    SearchSeedTreatmentComponent,
    RequestSeedTreatmentComponent,
    RequestSubmittedComponent,
    ArticleComponent,
    TermsAcceptorComponent,
    WarningEmptyIngredientComponent,
    MobileNavigationComponent,
    SearchHistoryComponent,
    //Nav
    NavigationComponent,
    MobileNavigationComponent,   
    //Helena
    NavigationHelenaComponent,
    HeaderHelenaComponent,
    HelenaSearchSeedTreatmentComponent,
    HelenaRequestSeedTreatmentComponent,
    HelenaSearchComponent,
    HelenaTankmixDetailComponent,
    HelenaRequestComponent,
    HelenaPrivacyComponent,
    HelenaArticleComponent,
    PdfIconComponent,
    ResultIconComponent

  ],
  imports: [
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(), CollapseModule.forRoot(),
    TypeaheadModule.forRoot(),
    BrowserModule, HttpClientModule,

    MarkdownModule.forRoot(),
    FormsModule, ReactiveFormsModule,
    FontAwesomeModule,
    RouterModule.forRoot(myRoutes, { enableTracing: false }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorker,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
      
    }),
  ],
  providers: [
    ApiService, MarkdownService, MarkedOptions,VersionUpdatesService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoggingInterceptor,
      multi: true
    },
    { provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } }

  ],
  bootstrap: [AppComponent]
})
export class AppModule {


}
